<template>
  <div class="presupuestos-gastos-list">
    <!-- <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          nombreLeyenda="Nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row> -->

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Presupuestos de Gastos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="presupuestosGastos" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(importeTotal)="data">
              {{ data.item.importeTotal | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Presupuesto</b-dropdown-item>
                <b-dropdown-item @click.stop="duplicar(data.item)">
                  <i class="fa fa-copy"></i>Duplicar Datos del Presupuesto</b-dropdown-item>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar Presupuesto</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Presupuesto</b-dropdown-item>

          <b-dropdown-divider/>
          
          <b-dropdown-item @click.stop="consultarComparativo">
            <i class="fa fa-info"></i>Consultar Comparativo</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestosGastos/getField',
  mutationType: 'presupuestosGastos/updateField',
});

export default {
  name: 'PresupuestosGastosList',
  components: {
    // appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal,
    confirmModal
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'periodo',
        },
        {
          key: 'importeTotal',
          label: 'Total',
          class:'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'presupuestosGastos',
      // 'nombre',
      // 'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    // filtrar(filtro) {
    //   this.nombre = filtro.nombre;
    //   this.incluirInactivos = filtro.incluirInactivos;
    //   this.paginaActual = 1;

    //   this.getItems();
    // },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('presupuestosGastos/getPresupuestosGastos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'PresupuestoGastosData', 
                          params: { id: item.id }})
    },
    editar (item) {
      this.$router.push({ name: 'PresupuestoGastosEdit', 
                          params: { id: item.id }})
    },
    duplicar (item) {
      this.$router.push({ name: 'PresupuestoGastosDuplicar', 
                          params: { id: item.id }})
    },
    agregar () {
      this.$router.push({ name: 'PresupuestoGastosAdd' })
    },
    consultarComparativo () {
      this.$router.push({ name: 'PresupuestosGastosComparativo' })
    },
    borrar(item) {
      this.showModalConfirm('¿Desea borrar el presupuesto de gastos seleccionado?', 
            this.borrarPresupuesto.bind(this, item.id), 'Si', null, 'No')
    },
    borrarPresupuesto(presupuestoGastosId) {
      this.showSpinner();
      this.$store.dispatch('presupuestosGastos/delete', presupuestoGastosId)
        .then(() => this.showModalMsj('El presupuesto se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
  .presupuestos-gastos-list table td {
    padding-top: 5px;
    padding-bottom: 5px;
    vertical-align: middle;
  }
  .presupuestos-gastos-list table td[aria-colindex="1"] {
    width: calc(80% - 60px);
  }
  .presupuestos-gastos-list table td[aria-colindex="2"] {
    width: 20%;
  }
  .presupuestos-gastos-list table td[aria-colindex="3"] {
    width: 60px
  }
</style>
